import { type CustomFieldColor } from '@air/api/types';
import { CheckIcon } from '@air/design-icons';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';

import { CustomFieldModalColorMenuTrigger } from '~/components/CustomFields/CustomFieldModal/CustomFieldModalForm/CustomFieldModalColorMenuTrigger';
import { CUSTOM_FIELD_MODAL_OPTION_COLOR_OPTION } from '~/constants/testIDs';

type CustomFieldModalColorMenuProps = {
  selectedColor: string;
  fontHex: string;
  handleColorClick: (backgroundColor: string, index: number) => void;
  index: number;
  colors: CustomFieldColor[];
};

const CustomFieldModalColorMenu = ({
  selectedColor,
  index,
  handleColorClick,
  colors,
  fontHex,
}: CustomFieldModalColorMenuProps) => {
  const menuOptions: DropdownMenuOption[] = colors.map((color) => {
    return {
      id: color.id,
      label: color.name,
      prefix: (
        <div
          className="mr-2 size-6 rounded-4"
          style={{ backgroundColor: color.backgroundHex }}
          // biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
          data-testid={`${CUSTOM_FIELD_MODAL_OPTION_COLOR_OPTION}-${color.name}`}
        />
      ),
      onSelect: () => handleColorClick(color.backgroundHex, index),
      // biome-ignore lint/suspicious/noUnnecessaryConditions: PLA-1724 — pre-existing debt, not introduced by the icon migration
      suffix: color.backgroundHex?.toLowerCase() === selectedColor?.toLowerCase() ? <CheckIcon size="sm" /> : null,
      type: 'item',
    };
  });

  return (
    <DropdownMenu
      size="small"
      trigger={<CustomFieldModalColorMenuTrigger selectedColor={selectedColor} fontHex={fontHex} />}
    >
      {renderDropdownItems({ options: menuOptions })}
    </DropdownMenu>
  );
};

export { CustomFieldModalColorMenu };
